
import React from 'react';
import { 
  LayoutDashboard, 
  Users, 
  Settings, 
  LogOut, 
  Clock 
} from 'lucide-react';

interface SidebarProps {
  currentView: string;
  setView: (view: any) => void;
  onLogout: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ currentView, setView, onLogout }) => {
  const items = [
    { id: 'dashboard', label: 'Overview', icon: LayoutDashboard },
    { id: 'clients', label: 'Clients', icon: Users },
    { id: 'settings', label: 'Settings', icon: Settings },
  ];

  return (
    <aside className="w-64 bg-white border-r border-slate-200 flex flex-col h-screen sticky top-0 transition-all">
      <div className="p-8 pt-[calc(env(safe-area-inset-top)+2rem)] flex items-center gap-3">
        <div className="bg-blue-600 p-2 rounded-lg text-white shadow-sm shadow-blue-500/20">
          <Clock size={20} strokeWidth={2.5} />
        </div>
        <span className="font-black text-lg tracking-tight text-slate-900">
          Timesheet <span className="text-blue-600">Pro</span>
        </span>
      </div>

      <nav className="flex-1 px-4 space-y-1 py-4">
        {items.map((item) => (
          <button
            key={item.id}
            onClick={() => setView(item.id)}
            className={`w-full flex items-center gap-3 px-4 py-2.5 rounded-xl transition-all duration-200 group ${
              currentView === item.id 
                ? 'bg-blue-50 text-blue-600 font-bold' 
                : 'text-slate-500 hover:bg-slate-50 hover:text-slate-800 font-semibold'
            } text-sm`}
          >
            <item.icon size={18} strokeWidth={currentView === item.id ? 2.5 : 2} className={currentView === item.id ? 'text-blue-600' : 'text-slate-400 group-hover:text-slate-600'} />
            <span>{item.label}</span>
          </button>
        ))}
      </nav>

      <div className="p-6 border-t border-slate-50 pb-[calc(env(safe-area-inset-bottom)+1.5rem)]">
        <button
          onClick={onLogout}
          className="w-full flex items-center gap-3 px-4 py-2.5 rounded-xl text-slate-400 hover:bg-red-50 hover:text-red-600 transition-all font-bold text-sm group"
        >
          <LogOut size={18} className="group-hover:text-red-600 transition-colors" />
          <span>Sign Out</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
